/**
 * Dependency imports
 */
import React from 'react';
import {
  FacebookAuthProvider,
  GoogleAuthProvider,
  signInWithPopup,
} from 'firebase/auth';
import { FirebaseError } from 'firebase/app';

/**
 * Local imports
 */
import { auth } from '@/firebase/auth';

export type AuthProvider = 'google' | 'facebook';

/**
 * Default export
 */
export const useProviderAuth = (provider: AuthProvider) => {
  const Provider = {
    google: GoogleAuthProvider,
    facebook: FacebookAuthProvider,
  }[provider];

  const selectedProvider = new Provider();

  const [info, setInfo] = React.useState<any>(null);
  const [status, setStatus] = React.useState<
    'idle' | 'pending' | 'complete' | 'error'
  >('idle');

  const parseFirebaseError = (err: FirebaseError) =>
    new Error(err.message.replace(/^Firebase:|\((.*?)\).$/g, '').trim(), {
      cause: err.code,
    });

  const authenticate = () => {
    setStatus('pending');

    signInWithPopup(auth, selectedProvider)
      .then((creds) => {
        setStatus('complete');
        setInfo(creds);
      })
      .catch((err) => {
        setStatus('error');
        setInfo(parseFirebaseError(err));
      });
  };

  return [
    authenticate,
    {
      info,
      status,
    },
  ] as const;
};
